// App.tsx
import React from 'react';
import Login from './Login';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Notifications from './components/Notifications';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './api';

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Notifications />
        <Router>
          <Routes>
            <Route path='/readyz' element={""} />
            <Route path='/*' element={<Login />} />
          </Routes>
        </Router>
      </QueryClientProvider>
    </>
  );
}

export default App;
